import { type OptionItem } from "@common/declarations";
import date from "@common/lib/date";
import { type I18n } from "@common/lib/i18n";

export type AccountOptionItem = OptionItem<{
  accountId: string;
  createdOnDate: string;
}>;

export const getMonthOptions = (
  i18n: I18n,
  accountOptions: AccountOptionItem[],
  accountId: string
): OptionItem<Date>[] =>
  date
    .eachMonthOfInterval(
      accountOptions.find((x) => x.value.accountId === accountId)?.value.createdOnDate ?? Date.now(),
      Date.now()
    )
    .sort((a, b) => b.getTime() - a.getTime())
    .map((x) => ({
      disabledTooltip: i18n.infoStatementAvailableNextMonth,
      isDisabled: date.isCurrentMonth(x),
      label: date.format(x, "YYYY MMM")!,
      value: x
    }));

export const getDefaultDateValue = (
  i18n: I18n,
  accountOptions: AccountOptionItem[],
  accountId: string
): Date | undefined => {
  const options = getMonthOptions(i18n, accountOptions, accountId);
  return options.find((x) => !x.isDisabled)?.value;
};
